/**
 * useDeploymentMode — the React binding for deployment mode (P-B2B-1).
 *
 * Lives in its own module rather than beside `RequireDeploymentSurface` so that
 * component file exports only components (react-refresh/only-export-components,
 * which CI enforces at --max-warnings=0).
 */

import { useTenantStore } from '@/stores/prioritization/tenantStore';
import { resolveDeploymentMode, type DeploymentMode } from './deploymentMode';

export interface DeploymentModeState {
  mode: DeploymentMode;
  /** False until a workspace row is actually in hand — never strip before then. */
  resolved: boolean;
}

/** Current workspace's deployment mode, defaulting to b2b until one resolves. */
export function useDeploymentMode(): DeploymentModeState {
  const workspaces = useTenantStore((s) => s.workspaces);
  const currentWorkspaceId = useTenantStore((s) => s.currentWorkspaceId);
  const workspace = workspaces.find((w) => w.id === currentWorkspaceId);
  return {
    mode: resolveDeploymentMode(workspace?.deploymentMode),
    resolved: Boolean(workspace),
  };
}
